import ACCESS_ENUM from "@/access/accessEnum";

/**
 * 全局校验
 */
const checkAccess = (
  loginUser: API.LoginUserVO,
  needAccess = "ACCESS_ENUM.NOT_LOGIN"
) => {
  //获取当前用户权限（如果没有loginUser则未登录）
  const loginUserAccess = loginUser?.userRole ?? ACCESS_ENUM.NOT_LOGIN;
  if (needAccess === ACCESS_ENUM.NOT_LOGIN) {
    return true;
  }
  //如果用户要登陆才能访问
  if (needAccess === ACCESS_ENUM.USER) {
    //如果用户没登录，无权限
    if (loginUserAccess === ACCESS_ENUM.NOT_LOGIN) {
      return false;
    }
  }
  //如果管理员才能访问
  if (needAccess === ACCESS_ENUM.ADMIN) {
    if (loginUserAccess !== ACCESS_ENUM.ADMIN) {
      return false;
    }
  }
  return true;
};

export default checkAccess;
